import { lxColor } from "../../../colors/variables";

export const defaultIconSize = 32;
export const defaultIconColor = lxColor("smoke");

export const defaultSpinnerSize = 48;
export const defaultSpinnerColor = lxColor("inari");
